import { httpService } from "../httpService.service";

// Home "Generate Reports" feature. Thin wrappers over the existing analytics
// endpoints already consumed by the dashboard summaries, so the report modals
// pull from the same source of truth the TPM/Site-visit summaries use.

// Aggregate TPM summary — site visits by stage, report pipeline, red-flag
// status, target-vs-completed visits, interviews, IP/donor reporting. Same
// endpoint the TPM Summary tab uses (getTPMsummary). The callback receives the
// full body; the payload lives under `.data`.
export const getTpmSummaryReport = (
  { projectId, year, month, quarter } = {},
  callback,
  errCallback
) => {
  const params = new URLSearchParams();
  if (projectId) params.append("projectId", projectId);
  if (year) params.append("year", year);
  if (month) params.append("month", month);
  if (quarter) params.append("Quarter", quarter);
  return httpService.get(
    `/api/Projects/getTPMsummary?${params.toString()}`,
    callback,
    errCallback
  );
};

// Deadline / on-time performance — planned vs completed, completed within the
// planned date vs late, and the average delay in days. Same endpoint the Visit
// Data Summary "Visits Planning & Execution" chart uses. Body payload is under
// `.data`.
export const getVisitTimelinessReport = (
  { projectId, startDate, endDate, country, state } = {},
  callback,
  errCallback
) => {
  const params = new URLSearchParams();
  if (projectId) params.append("ProjectId", projectId);
  if (startDate) params.append("StartDate", startDate);
  if (endDate) params.append("EndDate", endDate);
  if (country) params.append("Country", country);
  if (state) params.append("State", state);
  return httpService.get(
    `/api/Site/visitPlanningExecution?${params.toString()}`,
    callback,
    errCallback
  );
};
